import {
  SafeAreaView,
  VStack,
  Text,
  HStack,
  ScrollView
} from "@gluestack-ui/themed";
import { CustomHeader } from "@repo/core/components/layout/CustomHeader";
import { StatusBar } from "@repo/core/components/layout/StatusBar";
import { SupportController } from "./controller";
import { Icon } from "@repo/core/components/core/Icon";
import { Button } from "@repo/core/components/core/Button";
import { QrCode } from "@repo/core/components/core/QrCode";
import { HeaderStyleEnum } from "@repo/core/components/layout/CustomHeader/types";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";

function Support() {
  const {
    back,
    isTabletOrWeb,
    handleOpenWhatsAppNumber,
    handleCopyToClipboard
  } = SupportController();
  return (
    <VStack flex={1} bg="$backgroundLight100" overflow="hidden" height="$100vh">
      <StatusBar
        showCustomStatusBar
        statusBarVariant={StatusBarVariantEnum.GREEN}
      />
      <SafeAreaView flex={1} bg="$backgroundLight50">
        <VStack py="$4" space="lg" bg="$primary700">
          <CustomHeader
            title="Ajuda e Suporte"
            onBackPress={back}
            headerStyle={HeaderStyleEnum.transparent}
          />
        </VStack>
        <ScrollView
          contentContainerStyle={{
            gap: 24,
            paddingHorizontal: 16,
            paddingVertical: 16,
            flexDirection: isTabletOrWeb ? "row" : "column"
          }}
        >
          <VStack space="lg" flex={1}>
            <Text fontSize="$lg" mb={isTabletOrWeb ? "$0.5" : "$0"}>
              Nossos canais de atendimento:
            </Text>
            <VStack
              flex={1}
              p="$4"
              space="lg"
              borderRadius="$lg"
              borderWidth="$1"
              borderColor="$borderDark200"
            >
              <Text
                fontWeight="500"
                $web-fontFamily="Roboto"
                fontFamily="Roboto_500Medium"
              >
                Telefones
              </Text>
              <HStack alignItems="center" space="md">
                <Icon name="phone" size="sm" color="$primary600" />
                <VStack>
                  <Text fontWeight="700" color="$neutral900">
                    (51) 2112-2941
                  </Text>
                  <Text fontSize="$sm" color="$neutral800">
                    Segunda à sexta, das 7h às 18h
                  </Text>
                </VStack>
              </HStack>
              <Button
                leftIcon={{
                  name: "clipboard-check",
                  size: 18,
                  color: "$white",
                  hoverColor: "$white"
                }}
                text="Copiar número"
                variant="solid"
                onPress={() => handleCopyToClipboard("51 2112-2941")}
              />
            </VStack>

            {/* TODO: Will be added after alignment with the client */}
            {/* <VStack */}
            {/*   flex={isTabletOrWeb ? 0.4 : 1} */}
            {/*   p="$4" */}
            {/*   space="lg" */}
            {/*   borderRadius="$lg" */}
            {/*   borderWidth="$1" */}
            {/*   borderColor="$borderDark200" */}
            {/* > */}
            {/*   <Text */}
            {/*     fontWeight="500" */}
            {/*     $web-fontFamily="Roboto" */}
            {/*     fontFamily="Roboto_500Medium" */}
            {/*   > */}
            {/*     Chat */}
            {/*   </Text> */}
            {/*   <Text> */}
            {/*     Para conversar pelo nosso chat web, toque no botão abaixo: */}
            {/*   </Text> */}
            {/*   <Button */}
            {/*     leftIcon={{ name: "chat", size: 18 }} */}
            {/*     text="Conversar no chat" */}
            {/*     variant="solid" */}
            {/*   /> */}
            {/* </VStack> */}
          </VStack>
          <VStack
            // Flex breaks the QR Code component and makes it overflow in web responsive, but we need it in web and tablet breakpoints.
            flex={isTabletOrWeb ? 1 : undefined}
            p="$4"
            space="lg"
            borderRadius="$lg"
            borderWidth="$1"
            borderColor="$borderDark200"
            mt={isTabletOrWeb ? "$10" : "$0"}
          >
            <Text
              fontWeight="500"
              $web-fontFamily="Roboto"
              fontFamily="Roboto_500Medium"
            >
              WhatsApp
            </Text>
            <Text>
              Para conversar conosco pelo WhatsApp, toque no botão abaixo:
            </Text>
            <Button
              leftIcon={{ name: "whatsapp", size: 18 }}
              text="Abrir WhatsApp"
              variant="solid"
              onPress={handleOpenWhatsAppNumber}
            />

            <Text>
              Ou leia o QR code para abrir a conversa em outro dispositivo:
            </Text>
            <VStack alignItems="center" h="$full" flex={2}>
              <QrCode value={"mock_value"} showBorder={false} />
            </VStack>
          </VStack>
        </ScrollView>
      </SafeAreaView>
    </VStack>
  );
}

export default Support;
